export default "__VITE_ASSET__4969a646__"